/**
 * Portal（站台）身分 —— MP P2「站台身分外部化」。
 *
 * 這個前端就是 OneStep Place 這一個 Portal。在 P2 之前，站台身分散落在
 * nuxt.config.ts 的三段 if/else（seoSiteUrl）與各處字面值裡；要開第二個入口
 * 時得逐處尋找。這裡把「這個站台是誰」收成單一來源。
 *
 * 為什麼要往後端送 slug 而不是讓後端看 Host：
 *   - SSR 的請求是 Nitro 發出的，Host 是 API 主機（ssvc.*），不是使用者看到的網域。
 *   - portals.domain 是 UNIQUE 單值，裝不下同一個 Portal 的 prod / dev 兩個 host。
 *   - 少了 header 時後端會落回 Portal 0，也就是這個站台 —— 所以漏送不會壞，
 *     只是變成「靠預設值猜對」。第二個 Portal 上線時那個預設就是錯的答案。
 * 後端的完整理由見 backend/reservation-server/domain/portal.go。
 */

/** 必須與後端 domain.PortalHeader 一致。 */
export const PORTAL_HEADER = 'X-Portal-Slug'

interface PortalIdentity {
    /** 對應 portals.slug，是前後端之間的契約（不用數字 id，避免前端綁到內部編號）。 */
    slug: string
    name: string
    /** key 是 VITE_ENV；沒列到的環境（本機無 env）落回 dev 站台網域。 */
    siteUrl: Record<string, string>
}

export const PORTAL: PortalIdentity = {
    slug: 'onestep-place',
    name: 'OneStep Place',
    siteUrl: {
        prod: 'https://onestep.place',
        dev: 'https://www.dev.onestep.place',
    },
}

/** SEO 用的站台網址（@nuxtjs/sitemap 的 site.url、canonical、og:url 都吃這個）。 */
export function portalSiteUrl(env: string | undefined): string {
    return PORTAL.siteUrl[env ?? ''] || PORTAL.siteUrl.dev
}

/**
 * 打後端 API 時要帶的 Portal 標頭。
 * client 端與 Nitro server 端都用這一個，避免兩邊各寫一份字面值而拼錯不會報錯。
 */
export function portalHeaders(): Record<string, string> {
    return {[PORTAL_HEADER]: PORTAL.slug}
}
